module.exports = __webpack_public_path__ + "img/Assigned.bd617166.svg";